module.exports = __webpack_public_path__ + "img/vp01.6cd71b48.jpg";